import { ART_QUALITY_TUNING } from "../tuning/featureTuning";

/**
 * Device pixels per CSS pixel the artist's animations are drawn at on a `shape`: the screen's, at most 2 (the app's
 * `maxResolution` default), a phone's capped lower (`ART_QUALITY_TUNING`).
 */
export function artResolution(shape: string): number {
  const quality = shape === "desktop" ? ART_QUALITY_TUNING.desktop : ART_QUALITY_TUNING.phone;
  return Math.min(globalThis.devicePixelRatio || 1, quality.maxDeviceResolution);
}
